import { message } from "antd";
import CreateCustomNavigationAction from "../action/CreateCustomNavigationAction";
import { urlName } from "../../../config";
import UpdateCustomNavigationAction from "../action/UpdateCustomNavigationAction";


export const onUpdateSidebarData = ({ index, tabId, originalData, editedData }, disableLoader) => {
    var updatedFields = [];
    var updateMap = {}, isUpdate = false;
    var fd = new FormData();
    fd.append('domainName', urlName);
    fd.append('tabNumber', index);
    fd.append('tabId', tabId);
    if (originalData.tabName != editedData.tabName) {
        updateMap['tabName'] = editedData.tabName;
        updatedFields.push('tabName');
        isUpdate = true;
    }
    if (originalData.tooltipComment != editedData.tooltipComment) {
        updateMap['tooltipComment'] = editedData.tooltipComment;
        updatedFields.push('tooltipComment');
        isUpdate = true;
    }
    if (originalData.linkType != editedData.linkType) {
        updateMap['linkType'] = editedData.linkType;
        updatedFields.push('linkType');
        isUpdate = true;
    }
    if (originalData.link != editedData.link) {
        updateMap['link'] = editedData.link;
        updatedFields.push('link');
        isUpdate = true;
    }
    if (originalData.imageFile != editedData.imageFile) {
        fd.append('file', editedData.imageFile);
        updatedFields.push('imageFile');
        isUpdate = true;
    }
    fd.append('updateMap', JSON.stringify(updateMap));
    fd.append('updatedFields', JSON.stringify(updatedFields));
    if (isUpdate) {
        UpdateCustomNavigationAction.updateCustomNav(fd);
    } else {
        message.warning('No changes to update');
        disableLoader();
    }

};


export const onSendSidebarData = ({ tabData, index }, disableLoader) => {
    if (!tabData.hasOwnProperty('linkType')) {
        message.warning('Enter link Type');
        disableLoader();
    } else if (!tabData.hasOwnProperty('tabName') || tabData.tabName == '') {
        message.warning('Enter tab Name');
        disableLoader();
    } else if (!tabData.hasOwnProperty('link')) {
        message.warning('Enter link');
        disableLoader();
    } else if (!tabData.hasOwnProperty('tooltipComment') || tabData.tooltipComment === '') {
        message.warning('Enter tooltip Comment');
        disableLoader();
    } else if (!tabData.hasOwnProperty('imageFile')) {
        message.warning('Upload image File');
        disableLoader();
    } else {
        var sidebarFormData = new FormData();
        sidebarFormData.append('file', tabData.imageFile);
        sidebarFormData.append('linkType', tabData.linkType);
        sidebarFormData.append('tabName', tabData.tabName);
        sidebarFormData.append('link', tabData.link);
        sidebarFormData.append('domainName', urlName);
        sidebarFormData.append('tooltipComment', tabData.tooltipComment);
        sidebarFormData.append('tabNumber', index);
        CreateCustomNavigationAction.addNav(sidebarFormData);
    }
};